const navData: any[] = [{
  id: '1',
  name: 'CMS',
  roles: [],
  matchGroup: /^cms/,
  link: '/page/list',
}];

export default navData;
